import { DjangoModel } from './django-model';

interface ConstructorInterface<T> {
    new (input?: Partial<T>): T;
}

export class DjangoFactory {
    static toCamel(s) {
        return s.replace(/([-_][a-z])/gi, $1 => {
            return $1.toUpperCase().replace('-', '').replace('_', '');
        });
    }

    static toSnake(s) {
        return s.replace(/[0-9A-Z]/g, letter => `_${letter.toLowerCase()}`);
    }

    static deserialize<T>(input: any, fields: string[]): Partial<T> {
        const output = {};
        for (let field of fields) {
            output[field] = input[DjangoFactory.toSnake(field)];
        }
        return output;
    }

    static build<T extends DjangoModel>(
        type: ConstructorInterface<T>,
        data
    ): T {
        const instance = new type();
        instance.deserialize(data);
        return instance;
    }
    static buildMany<T extends DjangoModel>(
        type: ConstructorInterface<T>,
        data: any | any[]
    ): T[] {
        if (data && Array.isArray(data)) {
            return data.map(x => DjangoFactory.build(type, x));
        }
    }
    static buildDict<T extends DjangoModel>(
        type: ConstructorInterface<T>,
        data: any
    ): { [key: string]: T } {
        const returnObject = {};
        if (data) {
            for (let key of Object.keys(data)) {
                returnObject[key] = DjangoFactory.build(type, data[key]);
            }
        }
        return returnObject;
    }
}
